import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import { useDispatch } from 'react-redux';

import { fetchCampaignDetail } from 'features/views/campaignDashboards/campaignDetail/actions';
import dashboardStructure from 'features/views/campaignDashboards/structure';
import { equalOrThreeDashes, fromIsoDate, getCodelistPropById } from 'utils';

import CampaignNominationsButtons from './CampaignNominationsButtons';

export const CurrentCampaignsTableRow = ({ campaign, campaignChannels }) => {
	const dispatch = useDispatch();

	const handleChangeView = useCallback(() => {
		dispatch(fetchCampaignDetail(campaign.id));
		dispatch(dashboardStructure.actions.changeViewDependingOnRole(campaign.id));
	}, [dispatch, campaign.id]);

	const { fullName, channelId, startDate, endDate } = campaign;

	return (
		<>
			<TableCell>
				<Link underline="none" onClick={handleChangeView}>
					{equalOrThreeDashes(fullName)}
				</Link>
			</TableCell>
			<TableCell>{equalOrThreeDashes(getCodelistPropById(channelId, campaignChannels))}</TableCell>
			<TableCell>{equalOrThreeDashes(fromIsoDate(startDate))}</TableCell>
			<TableCell>{equalOrThreeDashes(fromIsoDate(endDate))}</TableCell>
			<TableCell>
				<CampaignNominationsButtons campaign={campaign} />
			</TableCell>
		</>
	);
};

CurrentCampaignsTableRow.propTypes = {
	campaign: PropTypes.object,
	campaignChannels: PropTypes.array,
};

export default CurrentCampaignsTableRow;
